import { downloadAPK } from "../../Helpers/DownloadAPK";
import menimage from "../../../images/bhau-images/money-man.png";
import countingimage from "../../../images/bhau-images/Counting.svg";

const Section2 = () =>{

const download = async (e) => {
  e.preventDefault();

  const newTab = window.open("about:blank", "_blank");

  if (!newTab) {
    alert("Popup blocked! Please allow popups.");
    return;
  }

  // Only favicon loader (tab ke upar spinner)
  const loaderIcon =
    "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><circle cx='50' cy='50' r='40' stroke='%23999' stroke-width='8' fill='none' stroke-dasharray='180'><animateTransform attributeName='transform' type='rotate' from='0 50 50' to='360 50 50' dur='1s' repeatCount='indefinite'/></circle></svg>";

  try {
    // Empty page
    newTab.document.open();
    newTab.document.write("<html><head></head><body></body></html>");
    newTab.document.close();

    // Set favicon (THIS IS YOUR “EARTH ICON LOADER”)
    const link = newTab.document.createElement("link");
    link.rel = "icon";
    link.href = loaderIcon;
    newTab.document.head.appendChild(link);

    newTab.document.title = "Loading...";

    const url = await downloadAPK();

    if (!url) {
      newTab.close();
      return;
    }

    // start download (no redirect flicker)
    const a = document.createElement("a");
    a.href = url;
    a.download = "boss555.apk";
    document.body.appendChild(a);
    a.click();
    a.remove();

    setTimeout(() => {
      newTab.close();
    }, 1500);
  } catch (err) {
    newTab.close();
    console.error(err);
  }
};

  return (
    <>
    
      <div className="container">
        <div className="banner-container">
          <div className="row main-contain-row">
            <div className="col-lg-12 order-1 order-lg-1 d-flex  justify-content-center">
              <div className="banner-left">
                <div className="button-sec">
                  <div className="row">
                    <div className="col-12">
                      <div
                        className="banner-text-section"
                  
                      >

                        <h1 >Play Games Win Money On BHAU777</h1>
                    
                      </div>
                    </div>
                  </div>
                  <img
                    className="count-img"
                    src={countingimage}
                    alt="Alternative Text Here"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-12 order-2 order-lg-2 text-center margin-t-15">
              <img
                className="banner-img"
                src={menimage}
                alt="Illustration of a scene with various elements"
              />
            </div>
          </div>
          <div className="download-now-btn move-color-animation d-flex justify-content-center align-items-center ">
            <h1
              className="mb-0 font-400 curser-pointer custom-font-size "
              onClick={download}
            >
              <i class="fa fa-hand-o-right hand-icon" aria-hidden="true"></i>
              Download App
              {/* <i class="fa fa-hand-o-right margin-l-10" aria-hidden="true"></i> */}
              <i class="fa fa-hand-o-left hand-icon" aria-hidden="true"></i>

            </h1>
            {/* <i className="fa-2x fa fa-download ms-4" aria-hidden="true"></i> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Section2;
